/*
 * Lector de códigos de barras y QR — projit.es
 *
 * Motor de lectura: ZXing (@zxing/browser + @zxing/library, MIT/Apache-2.0),
 * cargado antes que este fichero como `assets/zxing-browser.min.js`. Todo el
 * procesado ocurre en el navegador del visitante: ni el vídeo de la cámara
 * ni la imagen subida salen de su equipo.
 */
(function () {
  'use strict';

  if (typeof ZXingBrowser === 'undefined') {
    var avisoInicial = document.getElementById('lc-fatal');
    if (avisoInicial) avisoInicial.hidden = false;
    return;
  }

  var FORMATOS = {
    QR_CODE: 'QR Code',
    MICRO_QR_CODE: 'Micro QR Code',
    DATA_MATRIX: 'Data Matrix',
    AZTEC: 'Aztec Code',
    PDF_417: 'PDF417',
    MAXICODE: 'MaxiCode',
    CODE_128: 'Code 128',
    CODE_39: 'Code 39',
    CODE_93: 'Code 93',
    CODABAR: 'Codabar',
    ITF: 'Entrelazado 2 de 5 (ITF)',
    EAN_13: 'EAN-13',
    EAN_8: 'EAN-8',
    UPC_A: 'UPC-A',
    UPC_E: 'UPC-E',
    UPC_EAN_EXTENSION: 'Complemento EAN/UPC',
    RSS_14: 'GS1 DataBar',
    RSS_EXPANDED: 'GS1 DataBar Expandido'
  };

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    tabCamara: $('lc-tab-camara'),
    tabImagen: $('lc-tab-imagen'),
    panelCamara: $('lc-panel-camara'),
    panelImagen: $('lc-panel-imagen'),
    video: $('lc-video'),
    deviceRow: $('lc-device-row'),
    deviceSelect: $('lc-device-select'),
    startBtn: $('lc-start-btn'),
    stopBtn: $('lc-stop-btn'),
    torchBtn: $('lc-torch-btn'),
    cameraStatus: $('lc-camera-status'),
    fileInput: $('lc-file-input'),
    imagePreview: $('lc-image-preview'),
    imageStatus: $('lc-image-status'),
    resultEmpty: $('lc-result-empty'),
    resultCard: $('lc-result-card'),
    resultFormat: $('lc-result-format'),
    resultText: $('lc-result-text'),
    resultCopy: $('lc-result-copy'),
    resultOpen: $('lc-result-open'),
    historyList: $('lc-history-list'),
    historyEmpty: $('lc-history-empty'),
    historyClear: $('lc-history-clear')
  };

  if (!els.video || !els.tabCamara) return;

  // TRY_HARDER. `DecodeHintType` NO se reexporta en @zxing/browser -comprobado
  // en el navegador: `ZXingBrowser.DecodeHintType` es undefined-, así que se
  // usa el valor numérico del enum de @zxing/library (TRY_HARDER = 3). Que los
  // hints se aplican de verdad está comprobado por contraste: con
  // PURE_BARCODE (=1) sobre una imagen no pura, la lectura pasa a fallar.
  // Sin TRY_HARDER, un QR denso recomprimido en JPEG no se lee.
  var TRY_HARDER = 3;

  function nuevoLector() {
    var hints = new Map();
    hints.set(TRY_HARDER, true);
    return new ZXingBrowser.BrowserMultiFormatReader(hints);
  }

  var reader = nuevoLector();
  var torchOn = false;
  var ultimoTexto = null;
  var ultimoTiempo = 0;
  var historial = [];

  // -----------------------------------------------------------------
  // Utilidades
  // -----------------------------------------------------------------
  function nombreFormato(result) {
    try {
      var clave = ZXingBrowser.BarcodeFormat[result.getBarcodeFormat()];
      return FORMATOS[clave] || clave;
    } catch (e) {
      return 'Código';
    }
  }

  function pitar() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      var ctx = new Ctx();
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.12, ctx.currentTime);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
      osc.stop(ctx.currentTime + 0.1);
      osc.onended = function () { ctx.close(); };
    } catch (e) { /* silencio si el navegador no lo permite */ }
    if (navigator.vibrate) {
      try { navigator.vibrate(70); } catch (e) {}
    }
  }

  function pareceUrl(texto) {
    return /^https?:\/\//i.test(texto.trim());
  }

  function mostrarResultado(texto, formato, avisoSonoro) {
    els.resultEmpty.hidden = true;
    els.resultCard.hidden = false;
    els.resultFormat.textContent = formato;
    els.resultText.textContent = texto;
    if (pareceUrl(texto)) {
      els.resultOpen.hidden = false;
      els.resultOpen.href = texto;
    } else {
      els.resultOpen.hidden = true;
      els.resultOpen.removeAttribute('href');
    }
    if (avisoSonoro) pitar();
    agregarHistorial(texto, formato);
  }

  function agregarHistorial(texto, formato) {
    historial.unshift({ texto: texto, formato: formato, hora: new Date() });
    if (historial.length > 25) historial.length = 25;
    pintarHistorial();
  }

  function dosDigitos(n) { return n < 10 ? '0' + n : '' + n; }

  function pintarHistorial() {
    els.historyList.innerHTML = '';
    els.historyEmpty.hidden = historial.length > 0;
    historial.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'lc-history-item';
      var hora = dosDigitos(item.hora.getHours()) + ':' + dosDigitos(item.hora.getMinutes()) + ':' + dosDigitos(item.hora.getSeconds());
      var badge = document.createElement('span');
      badge.className = 'lc-history-badge';
      badge.textContent = item.formato;
      var texto = document.createElement('span');
      texto.className = 'lc-history-text';
      texto.textContent = item.texto;
      var horaEl = document.createElement('span');
      horaEl.className = 'lc-history-time';
      horaEl.textContent = hora;
      li.appendChild(badge);
      li.appendChild(texto);
      li.appendChild(horaEl);
      li.addEventListener('click', function () { mostrarResultado(item.texto, item.formato, false); });
      els.historyList.appendChild(li);
    });
  }

  // -----------------------------------------------------------------
  // Pestañas cámara / imagen
  // -----------------------------------------------------------------
  function activarPestana(modo) {
    var esCamara = modo === 'camara';
    els.tabCamara.classList.toggle('is-active', esCamara);
    els.tabCamara.setAttribute('aria-pressed', esCamara ? 'true' : 'false');
    els.tabImagen.classList.toggle('is-active', !esCamara);
    els.tabImagen.setAttribute('aria-pressed', !esCamara ? 'true' : 'false');
    els.panelCamara.hidden = !esCamara;
    els.panelImagen.hidden = esCamara;
    if (!esCamara) detenerCamara();
  }
  els.tabCamara.addEventListener('click', function () { activarPestana('camara'); });
  els.tabImagen.addEventListener('click', function () { activarPestana('imagen'); });

  // -----------------------------------------------------------------
  // Cámara en vivo
  // -----------------------------------------------------------------
  function traducirErrorCamara(e) {
    var nombre = (e && (e.name || e.message)) || String(e);
    if (/NotAllowedError|Permission/i.test(nombre)) {
      return 'Has bloqueado el acceso a la cámara. Actívalo en los permisos del navegador para este sitio y vuelve a intentarlo.';
    }
    if (/NotFoundError|DevicesNotFound/i.test(nombre)) {
      return 'No se ha encontrado ninguna cámara en este dispositivo. Prueba con "Subir imagen".';
    }
    if (/NotReadableError/i.test(nombre)) {
      return 'La cámara está siendo usada por otra aplicación. Ciérrala e inténtalo de nuevo.';
    }
    return 'No se ha podido acceder a la cámara: ' + nombre;
  }

  // El bucle de escaneo es propio, no el de ZXing (`decodeFromVideoDevice` /
  // `decodeFromConstraints`). Motivo medido: ese bucle decodifica el
  // fotograma ENTERO a resolución nativa, y con TRY_HARDER eso cuesta unos
  // 260 ms por intento en un portátil -varias veces más en un móvil-, con lo
  // que la cámara parece no detectar nada. Controlando el bucle se puede
  // recortar y reducir el fotograma, que además de ir mucho más rápido da
  // MÁS detalle sobre el código cuando está lejos, y se pueden alternar
  // estrategias entre fotogramas.
  var stream = null;
  var temporizador = null;
  var pistaVideo = null;
  var lienzoTrabajo = document.createElement('canvas');
  var estrategia = 0;
  var LADO_TRABAJO = 800;

  // Se alternan entre fotogramas: encuadre completo para cuando el código
  // llena la pantalla, y recortes centrales -a resolución nativa- para
  // cuando es pequeño o está lejos. La invertida rescata los códigos claros
  // sobre fondo oscuro, que ZXing no lee.
  var ESTRATEGIAS = [
    { recorte: 1, invertir: false },
    { recorte: 0.55, invertir: false },
    { recorte: 0.35, invertir: false },
    { recorte: 1, invertir: true }
  ];

  function dibujarFotograma(plan) {
    var vw = els.video.videoWidth;
    var vh = els.video.videoHeight;
    if (!vw || !vh) return null;

    var rw = Math.round(vw * plan.recorte);
    var rh = Math.round(vh * plan.recorte);
    var sx = Math.round((vw - rw) / 2);
    var sy = Math.round((vh - rh) / 2);

    var f = Math.min(1, LADO_TRABAJO / Math.max(rw, rh));
    lienzoTrabajo.width = Math.max(1, Math.round(rw * f));
    lienzoTrabajo.height = Math.max(1, Math.round(rh * f));

    var c = lienzoTrabajo.getContext('2d');
    c.filter = plan.invertir ? 'invert(1)' : 'none';
    c.drawImage(els.video, sx, sy, rw, rh, 0, 0, lienzoTrabajo.width, lienzoTrabajo.height);
    c.filter = 'none';
    return lienzoTrabajo;
  }

  function tick() {
    if (!stream) return;
    var plan = ESTRATEGIAS[estrategia % ESTRATEGIAS.length];
    estrategia++;
    var lienzo = dibujarFotograma(plan);
    if (lienzo) {
      try {
        var result = reader.decodeFromCanvas(lienzo);
        var texto = result.getText();
        var ahora = Date.now();
        var esNuevo = texto !== ultimoTexto || (ahora - ultimoTiempo) > 2500;
        ultimoTexto = texto;
        ultimoTiempo = ahora;
        if (esNuevo) mostrarResultado(texto, nombreFormato(result), true);
      } catch (e) { /* fotograma sin código: es lo normal */ }
    }
    temporizador = setTimeout(tick, 120);
  }

  function iniciarCamara(deviceId) {
    els.cameraStatus.hidden = true;
    els.startBtn.disabled = true;

    // `facingMode: environment` para que en el móvil abra la trasera y no la
    // de selfies. 1280x720 y no 1080p: por encima de eso el coste por intento
    // sube sin que se lean más códigos, porque igualmente se reduce a 800 px
    // para decodificar.
    var video = deviceId
      ? { deviceId: { exact: deviceId } }
      : { facingMode: { ideal: 'environment' } };
    video.width = { ideal: 1280 };
    video.height = { ideal: 720 };

    navigator.mediaDevices.getUserMedia({ video: video, audio: false })
      .then(function (s) {
        stream = s;
        pistaVideo = s.getVideoTracks()[0] || null;
        els.video.srcObject = s;
        els.video.setAttribute('playsinline', '');
        els.video.muted = true;
        return els.video.play().catch(function () { /* algunos navegadores ya la reproducen */ });
      })
      .then(function () {
        els.startBtn.hidden = true;
        els.stopBtn.hidden = false;
        els.cameraStatus.hidden = false;
        els.cameraStatus.className = 'lc-camera-status lc-analizando';
        els.cameraStatus.textContent = 'Cámara activa. Enfoca el código y mantenlo dentro del recuadro.';
        comprobarLinterna();
        poblarCamaras(deviceId);
        estrategia = 0;
        tick();
      })
      .catch(function (e) {
        els.cameraStatus.hidden = false;
        els.cameraStatus.className = 'lc-camera-status';
        els.cameraStatus.textContent = traducirErrorCamara(e);
        els.startBtn.disabled = false;
      });
  }

  function detenerCamara() {
    if (temporizador) { clearTimeout(temporizador); temporizador = null; }
    if (stream) {
      stream.getTracks().forEach(function (t) { t.stop(); });
      stream = null;
    }
    pistaVideo = null;
    els.video.srcObject = null;
    els.startBtn.hidden = false;
    els.startBtn.disabled = false;
    els.stopBtn.hidden = true;
    els.torchBtn.hidden = true;
    els.torchBtn.classList.remove('is-active');
    els.cameraStatus.hidden = true;
    els.cameraStatus.className = 'lc-camera-status';
    torchOn = false;
    ultimoTexto = null;
  }

  function comprobarLinterna() {
    var puede = false;
    try {
      var cap = pistaVideo && pistaVideo.getCapabilities && pistaVideo.getCapabilities();
      puede = !!(cap && cap.torch);
    } catch (e) { puede = false; }
    els.torchBtn.hidden = !puede;
  }

  els.torchBtn.addEventListener('click', function () {
    if (!pistaVideo) return;
    torchOn = !torchOn;
    pistaVideo.applyConstraints({ advanced: [{ torch: torchOn }] }).catch(function () {
      torchOn = !torchOn;
      els.torchBtn.classList.toggle('is-active', torchOn);
    });
    els.torchBtn.classList.toggle('is-active', torchOn);
  });

  function poblarCamaras(deviceIdActual) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return;
    navigator.mediaDevices.enumerateDevices().then(function (todos) {
      var camaras = todos.filter(function (d) { return d.kind === 'videoinput'; });
      if (camaras.length < 2) {
        els.deviceRow.hidden = true;
        return;
      }
      els.deviceSelect.innerHTML = '';
      camaras.forEach(function (d, i) {
        var opt = document.createElement('option');
        opt.value = d.deviceId;
        opt.textContent = d.label || ('Cámara ' + (i + 1));
        els.deviceSelect.appendChild(opt);
      });
      var actual = deviceIdActual ||
        (pistaVideo && pistaVideo.getSettings && pistaVideo.getSettings().deviceId);
      if (actual) els.deviceSelect.value = actual;
      els.deviceRow.hidden = false;
    }).catch(function () { els.deviceRow.hidden = true; });
  }

  els.deviceSelect.addEventListener('change', function () {
    detenerCamara();
    iniciarCamara(els.deviceSelect.value);
  });

  els.startBtn.addEventListener('click', function () { iniciarCamara(); });
  els.stopBtn.addEventListener('click', detenerCamara);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) detenerCamara();
  });
  window.addEventListener('pagehide', detenerCamara);

  // -----------------------------------------------------------------
  // Subir imagen
  // -----------------------------------------------------------------
  // Un solo intento sobre la imagen tal cual falla en los casos más
  // corrientes -una captura de móvil recomprimida, un código pequeño dentro
  // de una foto grande, un código en blanco sobre negro-. Medido: con un QR
  // denso a calidad JPEG 60, y con un código invertido, el intento único
  // falla y esta batería lee. Por eso se prueban varias versiones de la misma
  // imagen hasta que una decodifica.
  function cargarImagen(url) {
    return new Promise(function (res, rej) {
      var img = new Image();
      img.onload = function () { res(img); };
      img.onerror = function () { rej(new Error('no se pudo cargar la imagen')); };
      img.src = url;
    });
  }

  function aLienzo(fuente, ancho, alto, pintar) {
    var cv = document.createElement('canvas');
    cv.width = ancho;
    cv.height = alto;
    pintar(cv.getContext('2d'));
    return cv;
  }

  function escalar(img, maxLado) {
    var f = Math.min(1, maxLado / Math.max(img.width, img.height));
    var w = Math.max(1, Math.round(img.width * f));
    var h = Math.max(1, Math.round(img.height * f));
    return aLienzo(img, w, h, function (c) {
      c.imageSmoothingEnabled = true;
      c.imageSmoothingQuality = 'high';
      c.drawImage(img, 0, 0, w, h);
    });
  }

  function invertir(cv) {
    return aLienzo(cv, cv.width, cv.height, function (c) {
      c.filter = 'invert(1)';
      c.drawImage(cv, 0, 0);
    });
  }

  function rotar(cv, grados) {
    var recto = grados % 180 === 0;
    return aLienzo(cv, recto ? cv.width : cv.height, recto ? cv.height : cv.width,
      function (c) {
        c.translate((recto ? cv.width : cv.height) / 2, (recto ? cv.height : cv.width) / 2);
        c.rotate(grados * Math.PI / 180);
        c.drawImage(cv, -cv.width / 2, -cv.height / 2);
      });
  }

  // Recorte central: cuando el código es pequeño dentro de una foto grande,
  // reducir la imagen entera lo destruye; recortar conserva sus píxeles.
  function recorteCentral(img, fraccion) {
    var w = Math.round(img.width * fraccion);
    var h = Math.round(img.height * fraccion);
    return aLienzo(img, w, h, function (c) {
      c.drawImage(img, (img.width - w) / 2, (img.height - h) / 2, w, h, 0, 0, w, h);
    });
  }

  function respirar() {
    // Cede el hilo entre intentos para que el navegador repinte el estado y
    // la página no parezca colgada mientras se prueban las variantes.
    return new Promise(function (res) { setTimeout(res, 0); });
  }

  async function leerImagenRobusto(url) {
    var img = await cargarImagen(url);
    var lector = nuevoLector();
    var mayor = Math.max(img.width, img.height);

    var bases = [escalar(img, Math.min(mayor, 2000))];
    if (mayor > 1200) bases.push(escalar(img, 1200));
    if (mayor > 800) bases.push(escalar(img, 800));
    bases.push(recorteCentral(img, 0.6));

    for (var i = 0; i < bases.length; i++) {
      var base = bases[i];
      // Normal e invertida: ZXing no lee códigos claros sobre fondo oscuro.
      var variantes = [base, invertir(base)];
      for (var v = 0; v < variantes.length; v++) {
        // 0 y 180 bastan: TRY_HARDER ya prueba la orientación girada de los
        // códigos 1D, y los 2D localizan sus patrones en cualquier giro.
        var giros = [0, 180];
        for (var g = 0; g < giros.length; g++) {
          var lienzo = giros[g] ? rotar(variantes[v], giros[g]) : variantes[v];
          try {
            return lector.decodeFromCanvas(lienzo);
          } catch (e) { /* siguiente variante */ }
          await respirar();
        }
      }
    }
    throw new Error('NotFound');
  }

  var urlPrevia = null;

  els.fileInput.addEventListener('change', function () {
    var file = els.fileInput.files && els.fileInput.files[0];
    if (!file) return;

    // Se libera la anterior, no la actual: la vista previa sigue usándola.
    if (urlPrevia) URL.revokeObjectURL(urlPrevia);
    var url = URL.createObjectURL(file);
    urlPrevia = url;

    els.imagePreview.src = url;
    els.imagePreview.hidden = false;

    els.imageStatus.hidden = false;
    els.imageStatus.className = 'lc-image-status lc-analizando';
    els.imageStatus.textContent = 'Analizando la imagen…';

    leerImagenRobusto(url).then(function (result) {
      els.imageStatus.hidden = true;
      els.imageStatus.className = 'lc-image-status';
      mostrarResultado(result.getText(), nombreFormato(result), true);
    }).catch(function () {
      els.imageStatus.hidden = false;
      els.imageStatus.className = 'lc-image-status';
      els.imageStatus.textContent = 'No se ha detectado ningún código en esta imagen. Lo que más ayuda es recortar la foto alrededor del código; después, más luz y más enfoque.';
    });
  });

  // -----------------------------------------------------------------
  // Copiar resultado e historial
  // -----------------------------------------------------------------
  els.resultCopy.addEventListener('click', function () {
    var texto = els.resultText.textContent || '';
    if (!texto || !navigator.clipboard) return;
    navigator.clipboard.writeText(texto).then(function () {
      var original = els.resultCopy.textContent;
      els.resultCopy.textContent = 'Copiado';
      setTimeout(function () { els.resultCopy.textContent = original; }, 1500);
    });
  });

  els.historyClear.addEventListener('click', function () {
    historial = [];
    pintarHistorial();
  });

  // Arranque
  pintarHistorial();
})();
